export const firebaseConfig = {
  apiKey: "AIzaSyAVw1-BlF2g44bcgBa7w-gRKJXkvUKHL28",
  authDomain: "er-dev-7164a.firebaseapp.com",
  databaseURL:
    "https://er-dev-7164a-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "er-dev-7164a",
  storageBucket: "er-dev-7164a.appspot.com",
  messagingSenderId: "1078401978754",
  appId: "1:1078401978754:web:0a37597fd611997fbbbf9b",
  measurementId: "G-7Z10YPQBLW",
};
